import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=ddc90956&scoped=true&"
import script from "./Organisation.vue?vue&type=script&lang=js&"
export * from "./Organisation.vue?vue&type=script&lang=js&"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=ddc90956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc90956",
  null
  
)

export default component.exports